<template>
	<!-- Page Introduction Wrapper -->
	<div class="page-style-a">
		<div class="container">
			<div class="page-intro">
				<h2>Cart</h2>
				<ul class="bread-crumb">
					<li class="has-separator">
						<i class="ion ion-md-home"></i>
						<router-link :to="{name : 'Home'}">Home</router-link>
					</li>
					<li class="is-marked">
						<a href="cart.html">Cart</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<!-- Page Introduction Wrapper /- -->
	<!-- Cart-Page -->
	<div style="height: 300px" v-if="status.cart.loading">
		<vue-element-loading
			background-color="white"
			:active="true"
			:is-full-screen="false"
			spinner="spinner"
			color="#343a40"
			text="Please Wait.."
		/>
	</div>
	<vue-element-loading
		background-color="white"
		:active="status.coupon.loading"
		:is-full-screen="true"
		spinner="spinner"
		color="#343a40"
		text="Please Wait.."
	/>
	<!-- <Spinner v-if="status.cart.loading" /> -->
	<div
		class="page-cart u-s-p-t-80"
		v-if="getCarts.length != 0 && !status.cart.loading"
	>
		<div class="container">
			<div class="row">
				<div class="col-lg-12">
					<form>
						<!-- Products-List-Wrapper -->
						<CartProducts :getCarts="getCarts" />
						<!-- Products-List-Wrapper /- -->
						<!-- Coupon -->
						<div class="coupon-continue-checkout u-s-m-b-60">
							<div class="coupon-area" v-if="isLoggedIn">
								<h6>Enter your coupon code if you have one .</h6>
								<div class="coupon-field">
									<form @submit.prevent="handleCouponForm">
										<label class="sr-only" for="coupon-code">Apply Coupon</label>
										<input
											id="coupon-code"
											type="text"
											class="text-field"
											placeholder="Coupon Code"
											required
											v-model="coupon_code"
											autocomplete="off"
										/>
										<button type="submit" class="button">Apply Coupon</button>
									</form>
								</div>
							</div>
							<div class="coupon-area" v-else>
								<div class="button-area" style="text-align: unset">
									<a class="continue" @click="handleLogin">
										<i class="fa fa-lock"></i> Login to apply coupon code</a
									>
								</div>
							</div>
							<div class="button-area">
								<router-link class="continue" :to="{name: 'Home'}"
									>Continue Shopping</router-link
								>

								<router-link class="checkout" :to="{name: 'Checkout'}"
									>Proceed to Checkout</router-link
								>
							</div>
						</div>
						<!-- Coupon /- -->
					</form>
					<!-- Billing -->
					<div class="calculation u-s-m-b-60">
						<div class="table-wrapper-2">
							<table>
								<thead>
									<tr>
										<th colspan="2">Cart Totals</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="coupon">
										<td>
											<h3 class="calc-h3 u-s-m-b-0" id="tax-heading">Subtotal</h3>
											<span>
												(Coupon Code : {{ coupon.code }})
												<i @click="() => removeCoupon(coupon.code)" class="fa fa-times"></i
											></span>
										</td>
										<td>
											<div class="calc-text prev_total">
												{{ formatCurrency(TotalBeforeCoupon) }}
											</div>
											<div class="calc-text">
												-&nbsp;<b>{{ formatCurrency(coupon.amount) }}</b>
											</div>
											<div class="calc-text">
												{{ formatCurrency(getSubtotal) }}
											</div>
										</td>
									</tr>
									<tr v-else>
										<td>
											<h3 class="calc-h3 u-s-m-b-0" id="tax-heading">Subtotal</h3>
										</td>
										<td>
											<span class="calc-text">{{ formatCurrency(getSubtotal) }}</span>
										</td>
									</tr>
									<tr>
									</tr>
									<tr>
										<td>
											<h3 class="calc-h3 u-s-m-b-0" id="tax-heading">Tax</h3>
											<span> (GST)</span>
										</td>
										<td>
											<span class="calc-text">{{ formatCurrency(getTax) }}</span>
										</td>
									</tr>
										<tr>
										<td>
											<h3 class="calc-h3 u-s-m-b-0" id="tax-heading">Delivery Fee</h3>
										</td>
										<td>
											<span class="calc-text">{{ formatCurrency(GetDeliveryFee) }}</span>
										</td>
									</tr>
									<tr>
										<td>
											<h3 class="calc-h3 u-s-m-b-0">Total</h3>
										</td>
										<td>
											<span class="calc-text">{{ formatCurrency(getTotal) }}</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<!-- Billing /- -->
				</div>
			</div>
		</div>
	</div>

	<div
		class="page-cart u-s-p-t-80"
		v-if="getCarts.length == 0 && !status.cart.loading"
	>
		<div class="page-cart">
			<div class="">
				<div class="text-center">
					<h1>Em <i class="fas fa-child"></i>ty!</h1>
					<h5>Your cart is currently empty.</h5>
					<div class="redirect-link-wrapper u-s-p-t-25">
						<a class="redirect-link" href="/">
							<span>Return to Shop</span>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapActions, mapGetters} from "vuex";
	import CartProducts from "./CartProducts.vue";
	import Spinner from "../Loaders/Spinner.vue";
	import {formatCurrency} from "../../utils/common_functions";
	export default {
		components: {CartProducts, Spinner},
		computed: {
			...mapGetters("cart", [
				"getCarts",
				"getTax",
				"status",
				"getSubtotal",
				"getTotal",
				"coupon",
				"TotalBeforeCoupon",
				"GetDeliveryFee"
			]),
			...mapGetters("auth", ["isLoggedIn"]),
		},
		data() {
			return {
				coupon_code: "",
			};
		},
		methods: {
			formatCurrency,
			...mapActions("cart", ["updateCart", "fetchCart", "addCoupon", "removeCoupon"]),
			handleCouponForm() {
				this.addCoupon(this.coupon_code);
			},
			handleLogin() {
				localStorage.setItem("redirect", "Cart");
				this.$router.push({name: "Auth"});
			},
		},
		mounted() {},
	};
</script>

<style scoped>
	.fa-times {
		cursor: pointer;
	}
	.prev_total {
		text-decoration: line-through;
	}
</style>
